/**
* Lazy Loading
*/
function fnImgLazyLoading() {
	var myLazyLoad = new LazyLoad({
		elements_selector: ".lazy-img"
	});
}




/**
* Open a link in a new tab/window
*/
function fnPopup(event) {
	event.preventDefault();
	var sTarget = $(event.currentTarget).attr('href');
	var iWidth = 1024;
	var iHeight = 768;
	var iScrollbars = 2;
	var iLeft = (screen.width)?(screen.width-iWidth)/2:100;
	var iTop = (screen.height)?(screen.height-iHeight)/2:100;
	var sSettings='width='+iWidth+',height='+iHeight+',top='+iTop+',left='+iLeft+',scrollbars='+iScrollbars+',location=yes,directories=no,status=yes,menubar=yes,toolbar=yes,resizable=yes';
	window.open( sTarget, "", sSettings );
}




/**
* Animates to hash links when clicked
*/
function fnScrollToID() {

	// Handle links with @href started with '#' only
	$( document ).on( 'click', 'a[href^="#"]:not([href^="#tab"])', function(e) {
		if ( location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname ) {

			var target = $( this.hash );

			target = target.length ? target : $( '[name=' + this.hash.slice(1) +']' );

			if ( target.length ) {

				$( 'html, body' ).animate({
					scrollTop: target.offset().top + 0
				}, 1000, 'easeInOutQuart' );

				return false;
			}
		}
	});

}




/**
* Makes the dropdowns use a custom styling via dropkick
* http://dropkickjs.com/
*/
function fnDropdownStyling(){
	$( "main.primary select" ).dropkick({
		mobile: true
	});
}



var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
var videoCode = $('#youtube_player').attr('data-videoId');
function onYouTubeIframeAPIReady() {
player = new YT.Player('youtube_player', {
	height: '315',
	width: '560',
	videoId: videoCode,
	events: {
	'onReady': onPlayerReady,
	'onStateChange': onPlayerStateChange
	}
});
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
	event.target.playVideo();
}

// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
var done = false;
function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.PLAYING && !done) {
		setTimeout(stopVideo, 6000);
		done = true;
	}
}
function stopVideo() {
	player.stopVideo();
}



// END OF DOCUMENT
